// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3k-8Q","inputWrap":"styles_inputWrap__1xLYq","input":"styles_input__-gpHB"};